import View from "./view.js";
import OrthographicViewport from "../viewports/orthographic-viewport.js";
import OrthographicController from "../controllers/orthographic-controller.js";
export default class OrthographicView extends View {
    static { this.displayName = 'OrthographicView'; }
    constructor(props = {}) {
        super(props);
    }
    get ViewportType() {
        return OrthographicViewport;
    }
    get ControllerType() {
        return OrthographicController;
    }
}
